import { useMemo } from "react";
import { useProductsData } from "../../feature-module/crm/products/hooks/useProductsData";

const useProductOptions = (ofCompany) => {
  // Fetch products data using the custom hook
  const { data: products } = useProductsData({ ofCompany });

  return useMemo(() => {
    const productsData = products?.data?.data || [];

    // Extract product categories
    const productCategories = productsData.map((category) => ({
      value: category._id,
      label: category.name,
    }));

    // Map product names by category label instead of ID
    const productNamesByCategory = productsData.reduce((acc, category) => {
      acc[category.name] = category.products.map((product) => ({
        name: product.name, // Display in the dropdown
        id: parseInt(product._id),
        _id: product._id,
      }));
      return acc;
    }, {});

    return { productCategories, productNamesByCategory };
  }, [products]);
};

export default useProductOptions;
